<template>
    <a-input-number
        :disabled="disabled"
        :value="modelValue"
        :min="min"
        :max="max"
        :step="step"
        :parser="parser"
        :formatter="formatter"
        @change="updateValue"
    />
</template>

<script>
export default {
    props: {
        modelValue: [String, Number],
        disabled: false,
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: Infinity,
        },
        step: [String, Number],
        formatter: {
            type: Function,
            default: (value) => value,
        },
        parser: {
            type: Function,
            default: (value) => value,
        },
    },
    data() {
        return {
            setFormatting: true,
        };
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value);
            this.$emit('updatedValue');
        },
    },
};
</script>
